'use client';

import { useState, useEffect } from 'react';
import { usePathname, useSearchParams } from 'next/navigation';
import { sendGTMEvent } from '@next/third-parties/google';

let currentUrl = '';

export function NavigationEvents() {
  const pathname = usePathname();
  const searchParams = useSearchParams();
  const [previousPathname, setPreviousPathname] = useState<string | null>(null);

  useEffect(() => {
    setPreviousPathname(document.referrer);
  }, []);

  useEffect(() => {
    const url = window.location.toString();
    if (currentUrl !== url) {
      sendGTMEvent({
        event: 'virtual_page_view',
        page_url: url,
        page_title: document.title,
        previous_url: currentUrl === '' ? document.referrer : currentUrl
      });
      currentUrl = url;
    }
  }, [pathname, searchParams, previousPathname]);

  return null;
}
